import type { Member } from '@/entities/member/types';
import type { USER_ROLE } from '@/entities/user/constants';
import { socialApiClient } from '@/shared/api-client/social-api-client';

export const fetchMembers = async (workspaceId: string): Promise<Member[]> => {
  const response = await socialApiClient.get(`workspaces/${workspaceId}/members`);
  return response.json();
};

export const changeMemberRole = async (
  workspaceId: string,
  memberId: string,
  role: USER_ROLE,
): Promise<Member> => {
  const response = await socialApiClient.patch(`workspaces/${workspaceId}/member`, {
    json: {
      member_id: memberId,
      privilege: role,
    },
  });
  return await response.json();
};

export const removeMember = async (workspaceId: string, memberId: string): Promise<void> => {
  await socialApiClient.delete(`workspaces/${workspaceId}/member`, {
    json: {
      member_id: memberId,
    },
  });
};
